// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.faq-body ul,.faq-body ol{padding-left:25px}.faq-body iframe{display:block;margin:0 auto}`, "",{"version":3,"sources":["webpack://./client/components/FaqCard.vue"],"names":[],"mappings":"AAIE,0BAEE,iBAAA,CAGF,iBACE,aAAA,CACA,aAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
